export default __webpack_public_path__ + "static/media/4.3f396101.jpg";